
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2116',
  depVersions: {
  "customer-portal-app": "static-1.2116",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.459",
  "data-fetching-client": "static-1.9619",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.428",
  "growth-payments-core": "static-1.25197",
  "head-dlb": "static-1.4938",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5538",
  "hs-test-utils": "static-1.7961",
  "hub-http": "static-1.6166",
  "hub-http-shared-msw-handlers": "static-1.9828",
  "hubspot-dlb": "static-2.1832",
  "hubspot-prosemirror": "static-1.18065",
  "hubspot-url-utils": "static-1.4049",
  "HubStyleTokens": "static-2.11405",
  "I18n": "static-7.1610",
  "immutable": "static-2.77",
  "jasmine-runner": "static-1.6415",
  "payment-link-components": "static-1.23367",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6945",
  "quartz-core": "static-1.6164",
  "react": "static-7.184",
  "react-colorpicker": "static-2.10156",
  "react-dlb": "static-1.77",
  "react-utils": "static-2.5298",
  "rich-text-lib": "static-1.19728",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17903",
  "ui-components-test-utils": "static-1.5543",
  "UIComponents": "static-3.8352",
  "foundations-assets": "static-1.4798",
  "foundations-components": "static-1.7816",
  "foundations-theming": "static-1.4360",
  "foundations-theming-specialty": "static-1.2076",
  "framer-motion": "static-1.70",
  "metrics-js": "static-1.9542",
  "PortalIdParser": "static-2.388",
  "portals-platform-lib": "static-1.782",
  "quartz-config": "static-1.723",
  "quartz-routing": "static-1.375",
  "quick-fetch": "static-1.3871",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1-feature-id-1324-marker-timings.9",
  "rpc-client-utils": "static-1.4592",
  "sanitize-text": "static-1.8088",
  "styled-components": "static-2.88",
  "tanstack-table": "static-1.53",
  "ui-addon-draggable": "static-3.4715",
  "ui-addon-react-router-dom": "static-1.9491",
  "usage-tracker": "static-1.7282",
  "usage-tracker-anonymous": "static-1.5699",
  "usage-tracker-core": "static-1.7132",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven": "static-3.5829",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3357",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3222",
  "quartz-webpack": "static-1.3169",
  "bend-plugin-quartz-routing": "static-1.23",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.80",
  "customer-data-objects": "static-1.7606",
  "frontend-preferences-client": "static-1.7872",
  "laboratory-lib": "static-3.7104",
  "onboarding-scopes": "static-1.6408",
  "ui-addon-opt": "static-4.8320",
  "HeadJS": "static-2.740",
  "hs-test-utils-bend-plugin": "static-1.3072",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "hs-locale-management": "static-1.38",
  "ts-schema": "static-1.4032",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7662",
  "cssUtils": "static-1.778",
  "customer-data-ui-utilities": "static-1.9771",
  "HubStyle": "static-2.11713",
  "knowledge-content-types": "static-1.8479",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.620",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.486",
  "ui-addon-emoji-picker": "static-1.9833",
  "ui-addon-i18n": "static-1.11096",
  "ui-business-units-lib": "static-1.8991",
  "ui-shepherd-react": "static-3.10094",
  "video-components-external": "static-1.11082",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4270",
  "commerce-tours-lib": "static-1.5986",
  "customer-data-properties": "static-1.51346",
  "getting-started-shared-tasks": "static-1.18337",
  "growth-onboarding-reliability": "static-1.5027",
  "onboarding-tours": "static-1.16486",
  "reference-resolvers-lite": "static-1.8039",
  "sales-checkout-service-client": "static-1.3584",
  "ui-addon-iframeable": "static-1.8998",
  "user-context": "static-1.5046",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.826",
  "hubspotter-http": "static-1.4606",
  "icons": "static-2.643",
  "mobile-manifest-mixins": "static-1.514",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.620",
  "quartz-head": "static-1.610",
  "quartz-test": "static-1.620",
  "quartz-tracking": "static-1.324",
  "ui-fonts": "static-1.667",
  "usage-tracker-container": "static-1.7272",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9374",
  "data-token-picker": "static-1.16300",
  "FileManagerLib": "static-1.39091",
  "property-translator": "static-1.5348",
  "atom": "static-1.5017",
  "merchandise-lib": "static-1.262",
  "purchase-motions-components": "static-1.5780",
  "salesImages": "static-1.524",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5299",
  "react-select-plus": "static-1.103",
  "react-virtualized": "static-2.97",
  "ui-images": "static-2.1138",
  "bend-plugin-foundations-components": "static-1.4085",
  "floating-ui": "static-1.54",
  "react-aria": "static-1.64",
  "react-create-root-preference": "static-1.9",
  "trellis-assets": "static-1.1641",
  "bend-plugin-foundations-theming": "static-1.2843",
  "foundations-theming-base": "static-1.3345",
  "stylex": "static-1.31",
  "interframe": "static-3.4706",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5696",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "web-vitals": "static-1.3",
  "chirp-fetch": "static-1.1831",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4418",
  "react-flip-move": "static-1.68",
  "bender-build-tools": "static-1.3123",
  "inbound-db-properties-service-client": "static-1.3795",
  "superstore": "static-1.4712",
  "feedback-loader": "static-1.29192",
  "ai-components-ui-library": "static-1.8787",
  "ui-addon-video-player": "static-1.8643",
  "ui-coaching-tips": "static-1.28381",
  "sassPrefix": "static-1.154",
  "react-dnd-compat": "static-1.4565",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2441",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8115",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4594",
  "content-media-composition-data-lib": "static-1.12056",
  "content-media-compositions": "static-2.16063",
  "idb-keyval": "static-1.42",
  "immer": "static-1.33",
  "immerable": "static-1.4099",
  "magpie-lib": "static-1.5523",
  "magpie-types": "static-1.4983",
  "media-bridge-lib": "static-1.18824",
  "video-data-lib": "static-1.34740",
  "commerce-products-lib": "static-1.9311",
  "crm-message-bus": "static-1.42829",
  "growth-data-modal": "static-1.5335",
  "hubspot-apollo-client": "static-1.4822",
  "onboarding-tours-client": "static-1.4700",
  "calling-global-api": "static-1.64305",
  "calling-internal-common": "static-1.31246",
  "calling-lifecycle-internal": "static-1.65687",
  "calling-lifecycle-messages": "static-1.57981",
  "conditional-properties-service-client": "static-1.3751",
  "crm-links": "static-1.6225",
  "customer-data-objects-ui-components": "static-1.12968",
  "customer-data-properties-shared-msw-handlers": "static-1.9155",
  "customer-data-property-utils": "static-1.8029",
  "external-options-client-types": "static-1.4113",
  "file-manager-components": "static-1.23451",
  "framework-data-schema-resolvers": "static-1.6823",
  "google-libphonenumber": "static-1.36",
  "hs-resources": "static-1.87",
  "inbound-db-meta-service-client": "static-1.3545",
  "inbounddb-objects-service-types": "static-1.4178",
  "meetings-icalendar-utils-lib": "static-1.576",
  "multi-currency-client-types": "static-1.3646",
  "object-builder-ui-client": "static-1.48543",
  "pipeline-validation-client-types": "static-1.3920",
  "property-value-citations": "static-1.1960",
  "pulse": "static-1.498",
  "smart-property-lib": "static-1.6655",
  "tiered-pricing": "static-1.1085",
  "ui-addon-form-validation": "static-1.10934",
  "growth-onboarding-confetti": "static-1.3013",
  "growth-onboarding-next-action-utils": "static-1.1745",
  "navigation-components": "static-1.17823",
  "onboarding-tours-utils": "static-1.552",
  "ui-shepherd-tracker": "static-1.7475",
  "ui-universal-auth": "static-1.8903",
  "batch-promise": "static-1.1496",
  "navigation-messaging": "static-1.7150",
  "getting-started-shared-tasks-store": "static-1.17455",
  "hubspotter-http-shared-msw-handlers": "static-1.9826",
  "usage-tracker-session-replay": "static-1.4968",
  "audio-components": "static-1.5827",
  "FileManagerCore": "static-1.38950",
  "FileManagerImages": "static-1.36602",
  "video-components": "static-1.13085",
  "foundations-components-legacy": "static-1.841",
  "purchase-motions-api": "static-1.5783",
  "self-service-api": "static-1.10191",
  "signup-constants": "static-1.18737",
  "signup-ui-url-generator": "static-2.7982",
  "trials-service-types": "static-1.3848",
  "usage-tracker-public": "static-1.7093",
  "chatspot-core": "static-1.21008",
  "ContentUtils": "static-1.68189",
  "copilot-toolkit": "static-1.10962",
  "growth-onboarding-feedback-components": "static-1.6529",
  "reactive-lib": "static-1.666",
  "simple-logging-lib": "static-1.2994",
  "commerce-permissions": "static-1.710",
  "customer-data-tracking": "static-1.6831",
  "products-iframe-lib": "static-1.7759",
  "products-ui-components-shared-msw-handlers": "static-1.10210",
  "onboarding-data-sync-lib": "static-1.1860",
  "hubspot-apollo-cache": "static-1.281",
  "calling-error-reporting": "static-1.31252",
  "shared-worker-versioning": "static-1.10982",
  "calling-usage-tracker": "static-1.6487",
  "voice-sms-access-library": "static-1.750",
  "conversations-skeleton-state": "static-1.7194",
  "location-customization-utils-lib": "static-1.9071",
  "crm-pipelines-api-client-types": "static-1.4097",
  "framework-builder-read-service-client": "static-1.3964",
  "framework-data-schema-quick-fetch": "static-1.6728",
  "persist-promise": "static-1.3653",
  "bend-plugin-pulse": "static-1.1",
  "directed-graph": "static-1.881",
  "event-emitter": "static-1.894",
  "fast-json-patch": "static-1.61",
  "data-agent-kit": "static-1.102",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9911",
  "fsm": "static-1.3678",
  "policy-lib": "static-1.6717",
  "react-tinymce": "static-1.55076",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9974",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54202",
  "tinymce-plugins": "static-1.57316",
  "tinymce-themes": "static-1.56172",
  "growth-onboarding-next-action-components": "static-1.1773",
  "user-context-client": "static-1.4555",
  "nest": "static-1.169",
  "unified-auth-core-lib": "static-1.698",
  "amplitude-session-replay-browser": "static-1.58",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4477",
  "video-embed": "static-1.35574",
  "content-icons-ui": "static-1.2211",
  "social-insights-client-types": "static-1.21921",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4756",
  "integrations-lib": "static-1.15931",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4209",
  "InboxConnectUtils": "static-4.14638",
  "calling-orchestration-schema": "static-1.35527",
  "crm-record-cards-service-types": "static-1.3565",
  "highcharts": "static-8.102",
  "trellis-story-utils": "static-1.4461",
  "storybook-react": "static-1.31",
  "hub-http-contrib": "static-1.2985",
  "tinymce-data": "static-1.40287",
  "ui-addon-sales-email": "static-1.5155",
  "codemirror": "static-5.93",
  "layout-dnd-components": "static-1.12330",
  "layout-dnd-utils": "static-1.11305",
  "react-codemirror": "static-1.10569",
  "ui-brand-identity-lib": "static-1.14978",
  "NamespacedHubStyle": "static-2.9017",
  "outpost": "static-1.4135",
  "flux-actions": "static-1.330",
  "integrations-error-boundary-lib": "static-1.13346",
  "integrations-tracking-lib": "static-1.5542",
  "native-integrations-shared-strings": "static-1.7729",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10317",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.417",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68264",
  "layout-data-lib": "static-1.9630",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2957",
  "google-sheets-integration-lib": "static-1.65",
  "microsoft-drive-integration-lib": "static-1.172",
  "advanced-menus-core": "static-1.15036",
  "advanced-menus-lib": "static-1.11990",
  "ExportDialog": "static-6.10338",
  "ui-memberships-settings-lib": "static-1.33887",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15035",
  "simple-menus-lib": "static-1.16552"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2116",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.459",
  "data-fetching-client": "/data-fetching-client/static-1.9619",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.428",
  "growth-payments-core": "/growth-payments-core/static-1.25197",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5538",
  "hs-test-utils": "/hs-test-utils/static-1.7961",
  "hub-http": "/hub-http/static-1.6166",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9828",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18065",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyleTokens": "/HubStyleTokens/static-2.11405",
  "I18n": "/I18n/static-7.1610",
  "immutable": "/immutable/static-2.77",
  "jasmine-runner": "/jasmine-runner/static-1.6415",
  "payment-link-components": "/payment-link-components/static-1.23367",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6945",
  "quartz-core": "/quartz-core/static-1.6164",
  "react": "/react/static-7.184",
  "react-colorpicker": "/react-colorpicker/static-2.10156",
  "react-dlb": "/react-dlb/static-1.77",
  "react-utils": "/react-utils/static-2.5298",
  "rich-text-lib": "/rich-text-lib/static-1.19728",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17903",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5543",
  "UIComponents": "/UIComponents/static-3.8352",
  "foundations-assets": "/foundations-assets/static-1.4798",
  "foundations-components": "/foundations-components/static-1.7816",
  "foundations-theming": "/foundations-theming/static-1.4360",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2076",
  "framer-motion": "/framer-motion/static-1.70",
  "metrics-js": "/metrics-js/static-1.9542",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "portals-platform-lib": "/portals-platform-lib/static-1.782",
  "quartz-config": "/quartz-config/static-1.723",
  "quartz-routing": "/quartz-routing/static-1.375",
  "quick-fetch": "/quick-fetch/static-1.3871",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1-feature-id-1324-marker-timings.9",
  "rpc-client-utils": "/rpc-client-utils/static-1.4592",
  "sanitize-text": "/sanitize-text/static-1.8088",
  "styled-components": "/styled-components/static-2.88",
  "tanstack-table": "/tanstack-table/static-1.53",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4715",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9491",
  "usage-tracker": "/usage-tracker/static-1.7282",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5699",
  "usage-tracker-core": "/usage-tracker-core/static-1.7132",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven": "/raven/static-3.5829",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3357",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3222",
  "quartz-webpack": "/quartz-webpack/static-1.3169",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.23",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.80",
  "customer-data-objects": "/customer-data-objects/static-1.7606",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7872",
  "laboratory-lib": "/laboratory-lib/static-3.7104",
  "onboarding-scopes": "/onboarding-scopes/static-1.6408",
  "ui-addon-opt": "/ui-addon-opt/static-4.8320",
  "HeadJS": "/HeadJS/static-2.740",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3072",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "hs-locale-management": "/hs-locale-management/static-1.38",
  "ts-schema": "/ts-schema/static-1.4032",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7662",
  "cssUtils": "/cssUtils/static-1.778",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9771",
  "HubStyle": "/HubStyle/static-2.11713",
  "knowledge-content-types": "/knowledge-content-types/static-1.8479",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.620",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9833",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11096",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8991",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10094",
  "video-components-external": "/video-components-external/static-1.11082",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4270",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5986",
  "customer-data-properties": "/customer-data-properties/static-1.51346",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18337",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5027",
  "onboarding-tours": "/onboarding-tours/static-1.16486",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8039",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3584",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8998",
  "user-context": "/user-context/static-1.5046",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.826",
  "hubspotter-http": "/hubspotter-http/static-1.4606",
  "icons": "/icons/static-2.643",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.514",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.620",
  "quartz-head": "/quartz-head/static-1.610",
  "quartz-test": "/quartz-test/static-1.620",
  "quartz-tracking": "/quartz-tracking/static-1.324",
  "ui-fonts": "/ui-fonts/static-1.667",
  "usage-tracker-container": "/usage-tracker-container/static-1.7272",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9374",
  "data-token-picker": "/data-token-picker/static-1.16300",
  "FileManagerLib": "/FileManagerLib/static-1.39091",
  "property-translator": "/property-translator/static-1.5348",
  "atom": "/atom/static-1.5017",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "purchase-motions-components": "/purchase-motions-components/static-1.5780",
  "salesImages": "/salesImages/static-1.524",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5299",
  "react-select-plus": "/react-select-plus/static-1.103",
  "react-virtualized": "/react-virtualized/static-2.97",
  "ui-images": "/ui-images/static-2.1138",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4085",
  "floating-ui": "/floating-ui/static-1.54",
  "react-aria": "/react-aria/static-1.64",
  "react-create-root-preference": "/react-create-root-preference/static-1.9",
  "trellis-assets": "/trellis-assets/static-1.1641",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2843",
  "foundations-theming-base": "/foundations-theming-base/static-1.3345",
  "stylex": "/stylex/static-1.31",
  "interframe": "/interframe/static-3.4706",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5696",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "web-vitals": "/web-vitals/static-1.3",
  "chirp-fetch": "/chirp-fetch/static-1.1831",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4418",
  "react-flip-move": "/react-flip-move/static-1.68",
  "bender-build-tools": "/bender-build-tools/static-1.3123",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3795",
  "superstore": "/superstore/static-1.4712",
  "feedback-loader": "/feedback-loader/static-1.29192",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8787",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8643",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28381",
  "sassPrefix": "/sassPrefix/static-1.154",
  "react-dnd-compat": "/react-dnd-compat/static-1.4565",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2441",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8115",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4594",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12056",
  "content-media-compositions": "/content-media-compositions/static-2.16063",
  "idb-keyval": "/idb-keyval/static-1.42",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4099",
  "magpie-lib": "/magpie-lib/static-1.5523",
  "magpie-types": "/magpie-types/static-1.4983",
  "media-bridge-lib": "/media-bridge-lib/static-1.18824",
  "video-data-lib": "/video-data-lib/static-1.34740",
  "commerce-products-lib": "/commerce-products-lib/static-1.9311",
  "crm-message-bus": "/crm-message-bus/static-1.42829",
  "growth-data-modal": "/growth-data-modal/static-1.5335",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4822",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4700",
  "calling-global-api": "/calling-global-api/static-1.64305",
  "calling-internal-common": "/calling-internal-common/static-1.31246",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65687",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57981",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3751",
  "crm-links": "/crm-links/static-1.6225",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12968",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9155",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8029",
  "external-options-client-types": "/external-options-client-types/static-1.4113",
  "file-manager-components": "/file-manager-components/static-1.23451",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6823",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "hs-resources": "/hs-resources/static-1.87",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3545",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4178",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.576",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3646",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48543",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3920",
  "property-value-citations": "/property-value-citations/static-1.1960",
  "pulse": "/pulse/static-1.498",
  "smart-property-lib": "/smart-property-lib/static-1.6655",
  "tiered-pricing": "/tiered-pricing/static-1.1085",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10934",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3013",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1745",
  "navigation-components": "/navigation-components/static-1.17823",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.552",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7475",
  "ui-universal-auth": "/ui-universal-auth/static-1.8903",
  "batch-promise": "/batch-promise/static-1.1496",
  "navigation-messaging": "/navigation-messaging/static-1.7150",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17455",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9826",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4968",
  "audio-components": "/audio-components/static-1.5827",
  "FileManagerCore": "/FileManagerCore/static-1.38950",
  "FileManagerImages": "/FileManagerImages/static-1.36602",
  "video-components": "/video-components/static-1.13085",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.841",
  "purchase-motions-api": "/purchase-motions-api/static-1.5783",
  "self-service-api": "/self-service-api/static-1.10191",
  "signup-constants": "/signup-constants/static-1.18737",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7982",
  "trials-service-types": "/trials-service-types/static-1.3848",
  "usage-tracker-public": "/usage-tracker-public/static-1.7093",
  "chatspot-core": "/chatspot-core/static-1.21008",
  "ContentUtils": "/ContentUtils/static-1.68189",
  "copilot-toolkit": "/copilot-toolkit/static-1.10962",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6529",
  "reactive-lib": "/reactive-lib/static-1.666",
  "simple-logging-lib": "/simple-logging-lib/static-1.2994",
  "commerce-permissions": "/commerce-permissions/static-1.710",
  "customer-data-tracking": "/customer-data-tracking/static-1.6831",
  "products-iframe-lib": "/products-iframe-lib/static-1.7759",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10210",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1860",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.281",
  "calling-error-reporting": "/calling-error-reporting/static-1.31252",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10982",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6487",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.750",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7194",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9071",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4097",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3964",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6728",
  "persist-promise": "/persist-promise/static-1.3653",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.1",
  "directed-graph": "/directed-graph/static-1.881",
  "event-emitter": "/event-emitter/static-1.894",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "data-agent-kit": "/data-agent-kit/static-1.102",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9911",
  "fsm": "/fsm/static-1.3678",
  "policy-lib": "/policy-lib/static-1.6717",
  "react-tinymce": "/react-tinymce/static-1.55076",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9974",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54202",
  "tinymce-plugins": "/tinymce-plugins/static-1.57316",
  "tinymce-themes": "/tinymce-themes/static-1.56172",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1773",
  "user-context-client": "/user-context-client/static-1.4555",
  "nest": "/nest/static-1.169",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.698",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4477",
  "video-embed": "/video-embed/static-1.35574",
  "content-icons-ui": "/content-icons-ui/static-1.2211",
  "social-insights-client-types": "/social-insights-client-types/static-1.21921",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4756",
  "integrations-lib": "/integrations-lib/static-1.15931",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4209",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14638",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35527",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3565",
  "highcharts": "/highcharts/static-8.102",
  "trellis-story-utils": "/trellis-story-utils/static-1.4461",
  "storybook-react": "/storybook-react/static-1.31",
  "hub-http-contrib": "/hub-http-contrib/static-1.2985",
  "tinymce-data": "/tinymce-data/static-1.40287",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5155",
  "codemirror": "/codemirror/static-5.93",
  "layout-dnd-components": "/layout-dnd-components/static-1.12330",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11305",
  "react-codemirror": "/react-codemirror/static-1.10569",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14978",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9017",
  "outpost": "/outpost/static-1.4135",
  "flux-actions": "/flux-actions/static-1.330",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13346",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5542",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7729",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10317",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.417",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68264",
  "layout-data-lib": "/layout-data-lib/static-1.9630",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2957",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.65",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.172",
  "advanced-menus-core": "/advanced-menus-core/static-1.15036",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11990",
  "ExportDialog": "/ExportDialog/static-6.10338",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33887",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15035",
  "simple-menus-lib": "/simple-menus-lib/static-1.16552"
}
};
